import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";

export class Evergreen1ChartJS extends AlgoBase {

  constructor(target) {
    super('evergreen', target);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Evergreen1.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Occupancy Profile %', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          animation: false,
          borderColor: '#6400FF',
        }, {
          label: 'Damper', // [dynamic value in loadDataset()],
          data: this.algortihmData.dampers[0],
          animation: false,
          borderColor: '#E62B33',
        }, {
          label: 'Damper Without AI', // [dynamic value in loadDataset()],
          data: this.algortihmData.dampers[1],
          animation: false,
          borderColor: '#000000',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 6),
          y: {
            min: 0,
            max: 100,
            grid: {drawOnChartArea: false},
            ticks: {
              callback: function (value, index, ticks) {
                return value + '%';
              }
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              filter: function(item, chartData) {
                return !item.hidden
              }
            }
          }
        },
        layout: {
          padding: {
            left: 20,
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {

    // Important: we need to get the offset here too because otherwise the wrong dataset will be converted to celcius if needed
    const offset = (this.aiEnabled ? 0 : 1);

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 1);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 1);
    this.chart.data.datasets[2].label = this.getLegendFromCMS(3, 1)

    this.chart.setDatasetVisibility(1, this.aiEnabled);

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    const singleDataSetBuild = await super.buildDatasetFromCSV(filename, 1);
    const occupancyProfile = singleDataSetBuild.mainDatasets.shift()
    const damperOld = singleDataSetBuild.mainDatasets.shift()
    const damperNew = singleDataSetBuild.mainDatasets.shift()
    return {
      labels: singleDataSetBuild.labels,
      mainDatasets: [occupancyProfile],
      dampers: [damperNew, damperOld],
      allDampers: [damperNew, damperOld],
    };
  }

}
